import RuleList from 'alertRules/components/RuleList';
import { RuleAccordionProps } from 'alertRules/components/RuleAccordion';

type Props = {
  data: RuleAccordionProps[];
  isLoading: boolean;
};

const DigestRulesList = ({ data, isLoading }: Props) => (
  <RuleList
    data={data}
    isLoading={isLoading}
    emptyStateTitle="Create your first digest rule"
    emptyStateDescription="Ex: send a daily summary of all failures to #data-alerts-channel"
  />
);

export default DigestRulesList;
